<template>
  <div>
    <Card>
     <MaterialHeader @ResetHandleClick="ResetHandleClick"/>
     <div style="margin-left: 1rem;margin-bottom: 1rem;"><Button type="info" shape="circle" icon="md-add" @click="NewBuildHandleClick">新增</Button></div>
     <MaterialTable :MaterialinfoLists="MaterialinfoLists" @QueryHandleClick="QueryHandleClick" @EditHandleClick="EditHandleClick" @DeleteHandleClick="DeleteHandleClick"/>
     <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
     <Spin size="large" fix v-if="SpinShow"></Spin>
    </Card>
    <!-- 抽屉 -->
     <span></span>
      <Drawer title="物料信息维护" v-model="isDrawer" width="80" :mask-closable="false">
        <Form  :model="FormData" ref="formCustom" :rules="ruleCustom">
          <FormItem>
               <Avatar :src="FormData.material_icon" style="margin-left:2rem"/>
           </FormItem>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="物料ID">
                <Input  v-model="FormData.materiel_code" value="FormData.materiel_code"  disabled/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="物料名称" prop="materiel_name">
                <Input  v-model="FormData.materiel_name" value="FormData.materiel_name" />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="物料大类" prop="material_category">
                <Button type="info" @click="categorySelectHandleClick" long ghost>{{FormData.material_category}}</Button>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="物料状态" prop="material_state">
                <Select v-model="FormData.material_state" clearable value="FormData.material_state">
                  <Option value="正常">正常</Option>
                  <Option value="失效">失效</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="类型" >
                <Select v-model="FormData.type" clearable value="FormData.type" :disabled="this.State === 1" @on-change="TypeChangeHandle">
                  <Option value="常规">常规</Option>
                  <Option value="非标">非标</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
            </Col>
          </Row>
          <FormItem label="属性汇总">
                <Input  v-model="FormData.material_subclass" value="info.material_subclass" disabled/>
          </FormItem>
          <FormItem :label="item.AttributesName"  v-for="(item, index1) of FormData.material_lists" :key="item.AttributesID">
                <Button v-if="FormData.type === '常规'" type="info" @click="AttributeSelectHandleClick(index1)" long ghost>{{FormData.material_lists[index1].Currentvalue}}</Button>
                <Input v-if="FormData.type === '非标'" v-model="FormData.material_lists[index1].Currentvalue" :value="FormData.material_lists[index1].Currentvalue"/>
          </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
      </Drawer>
      <Drawer title="属性选择" :closable="false" v-model="isDrawer2">
        <RadioGroup vertical v-if="Current === 1">
          <div v-for="(item, index) of selectionlist" :key="item.Attributes_value_ID" @click="RoadioHandleClick(index)">
            <Radio :label="item.Name"></Radio>
          </div>
        </RadioGroup>
        <RadioGroup vertical v-else>
          <div v-for="(item, index) of categorylist" :key="item.ClassificationID" @click="CategoryRoadioHandleClick(index)">
            <Radio :label="item.Classification"></Radio>
          </div>
        </RadioGroup>
      </Drawer>
  </div>
</template>

<script>
import MaterialTable from './component/MaterialTable.vue'
import MaterialHeader from './component/MaterialHeader.vue'
import { MaterialInformationList, MaterialInformationList1, MaterialModalSelectionData, MaterialCategory, ChangeMaterialInformation } from '../../../api/Materiel'
import config from '../../../config/index'
export default {
  name: 'MaterialInformation',
  components: {
    MaterialTable,
    MaterialHeader
  },
  data () {
    // const validatematerialicon = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请上传图标'))
    //   }
    //   callback()
    // }
    const validatematerielname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入物料名称'))
      }
      callback()
    }
    const validatematerialcategory = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择物料大类'))
      }
      callback()
    }
    const validatematerialstate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择物料状态'))
      }
      callback()
    }
    return {
      baseUrl: '',
      MaterialinfoLists: [],
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      SpinShow: false,
      query: false,
      formItem: {},
      headers: {
        Authorization: 'Bearer ' + this.$store.state.token
      },
      State: 0,
      isDrawer: false,
      isDrawer2: false,
      FormData: {
        materiel_code: '',
        materiel_name: '',
        material_category: '',
        material_state: '',
        material_subclass: '',
        material_icon: '',
        ClassificationID: '',
        Attribute_Warehouse_Product_id: '',
        material_lists: [],
        type: ''
      },
      selectionlist: [],
      index: 0,
      categorylist: [],
      Current: 1, // 1 代表selectionlist 2代表categorylist
      ruleCustom: {
        // material_icon: [{ validator: validatematerialicon, trigger: 'blur' }],
        materiel_name: [{ validator: validatematerielname, trigger: 'blur' }],
        material_category: [{ validator: validatematerialcategory, trigger: 'blur' }],
        material_state: [{ validator: validatematerialstate, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.getMaterialInformationList()
    this.baseUrl = config.baseUrl.pro
  },
  methods: {
    // 获取物料信息数据
    getMaterialInformationList () {
      this.SpinShow = true
      MaterialInformationList(this.CurrentPage, this.pageSize).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.MaterialinfoLists = res.Data.Table1
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        if (this.query) {
          this.QueryHandleClick(this.formItem)
        } else {
          this.getMaterialInformationList()
        }
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        if (this.query) {
          this.QueryHandleClick(this.formItem)
        } else {
          this.getMaterialInformationList()
        }
      }
    },
    // 点击查询按钮回调
    QueryHandleClick (formItem) {
      this.SpinShow = true
      this.query = true
      this.CurrentPage = 1
      let state = 0
      this.formItem = formItem
      if (this.formItem.material_state === '正常') {
        state = 1
      } else if (this.formItem.material_state === '失效') {
        state = 2
      }
      MaterialInformationList1({
        materiel_code: this.formItem.materiel_code,
        materiel_name: this.formItem.materiel_name,
        material_category: this.formItem.material_category,
        material_state: state,
        material_type: this.formItem.material_type,
        material_subclass: this.formItem.material_subclass,
        CurrentPage: this.CurrentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.MaterialinfoLists = res.Data.Table1
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    // 点击重置按钮
    ResetHandleClick () {
      this.CurrentPage = 1
      this.getMaterialInformationList()
      this.query = false
    },
    // 点击新增按钮触发事件
    NewBuildHandleClick () {
      this.State = 0
      this.FormData = {
        materiel_code: '',
        materiel_name: '',
        material_category: '',
        material_state: '',
        material_subclass: '',
        material_icon: '',
        ClassificationID: '',
        Attribute_Warehouse_Product_id: '',
        material_lists: [],
        type: ''
      }
      this.isDrawer = true
    },
    // 点击编辑回调
    EditHandleClick (index) {
      this.SpinShow = true
      this.State = 1
      let type = 0
      if (this.MaterialinfoLists[index].type === '非标') {
        type = 1
      }
      MaterialModalSelectionData(this.MaterialinfoLists[index].ClassificationID, this.MaterialinfoLists[index].Attribute_Warehouse_Product_id, type).then(res => {
        if (res.IsSuccess) {
          this.FormData = {
            materiel_code: this.MaterialinfoLists[index].materiel_code,
            materiel_name: this.MaterialinfoLists[index].materiel_name,
            material_category: this.MaterialinfoLists[index].material_category,
            material_state: this.MaterialinfoLists[index].material_state,
            material_subclass: this.MaterialinfoLists[index].material_subclass,
            material_icon: this.MaterialinfoLists[index].material_icon,
            Attribute_Warehouse_Product_id: this.MaterialinfoLists[index].Attribute_Warehouse_Product_id,
            ClassificationID: this.MaterialinfoLists[index].ClassificationID,
            material_lists: res.Data,
            type: this.MaterialinfoLists[index].type
          }
          this.isDrawer = true
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    // 点击删除回调
    DeleteHandleClick (index) {
      this.State = 2
      let type = 0
      if (this.MaterialinfoLists[index].type === '非标') {
        type = 1
      }
      MaterialModalSelectionData(this.MaterialinfoLists[index].ClassificationID, this.MaterialinfoLists[index].Attribute_Warehouse_Product_id, type).then(res => {
        if (res.IsSuccess) {
          this.FormData = {
            materiel_code: this.MaterialinfoLists[index].materiel_code,
            materiel_name: this.MaterialinfoLists[index].materiel_name,
            material_category: this.MaterialinfoLists[index].material_category,
            material_state: this.MaterialinfoLists[index].material_state,
            material_subclass: this.MaterialinfoLists[index].material_subclass,
            material_icon: this.MaterialinfoLists[index].material_icon,
            Attribute_Warehouse_Product_id: this.MaterialinfoLists[index].Attribute_Warehouse_Product_id,
            ClassificationID: this.MaterialinfoLists[index].ClassificationID,
            material_lists: res.Data,
            type: this.MaterialinfoLists[index].type
          }
          this.OKHandleClick()
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    // 点击属性后回调
    AttributeSelectHandleClick (index) {
      this.Current = 1
      this.index = index
      this.selectionlist = this.FormData.material_lists[index].PriceModalValue
      this.isDrawer2 = true
    },
    // Roadio选择后回调
    RoadioHandleClick (index) {
      this.FormData.material_lists[this.index].Currentvalue = this.selectionlist[index].Name
      this.FormData.material_lists[this.index].Currentvalueid = this.selectionlist[index].Attributes_value_ID
      this.isDrawer2 = false
    },
    // 抽屉1取消回调
    CancelHandleClick () {
      this.isDrawer = false
      this.FormData = {
        materiel_code: '',
        materiel_name: '',
        material_category: '',
        material_state: '',
        material_subclass: '',
        material_icon: '',
        ClassificationID: '',
        Attribute_Warehouse_Product_id: '',
        material_lists: []
      }
    },
    // 抽屉1提交回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let check = true
          let subclass = ''
          for (let i = 0; i < this.FormData.material_lists.length; ++i) {
            if (!this.FormData.material_lists[i].Currentvalue) { check = false }
            if (i === 0) {
              subclass = this.FormData.material_lists[i].Currentvalue
            } else {
              subclass = subclass + '\\' + this.FormData.material_lists[i].Currentvalue
            }
          }
          if (check) {
            this.FormData.material_subclass = subclass
            this.isDrawer = false
            this.OKHandleClick()
          } else {
            this.$Modal.error({
              title: '有属性没选择！',
              content: '有属性没选择！'
            })
          }
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 点击大类后回调
    categorySelectHandleClick () {
      this.Current = 2
      MaterialCategory().then(res => {
        if (res.IsSuccess) {
          this.categorylist = res.Data
          this.isDrawer2 = true
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 大类选择后回调
    CategoryRoadioHandleClick (index) {
      this.FormData.material_category = this.categorylist[index].Classification
      this.FormData.ClassificationID = this.categorylist[index].ClassificationID
      this.isDrawer2 = false
      let type = 0
      if (this.FormData.type === '非标') {
        type = 1
      }
      MaterialModalSelectionData(this.FormData.ClassificationID, '', type).then(res => {
        if (res.IsSuccess) {
          this.FormData = {
            materiel_code: this.FormData.materiel_code,
            materiel_name: this.FormData.materiel_name,
            material_category: this.FormData.material_category,
            material_state: this.FormData.material_state,
            material_subclass: '',
            material_icon: this.FormData.material_icon,
            Attribute_Warehouse_Product_id: this.FormData.Attribute_Warehouse_Product_id,
            ClassificationID: this.FormData.ClassificationID,
            material_lists: res.Data
          }
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 更新物料信息
    OKHandleClick () {
      let state = 1
      if (this.FormData.material_state === '失效') { state = 2 }
      let Attributeslist = []
      let Attributeslist1 = []
      if (this.FormData.material_lists.length > 0) {
        this.FormData.material_lists.forEach(element => {
          if (this.FormData.type === '非标') {
            Attributeslist1.push({
              Attributes_value_ID: element.Currentvalueid,
              ClassificationID: this.FormData.ClassificationID,
              AttributesID: element.AttributesID,
              Name: element.Currentvalue,
              Sort: 1,
              type: 1 // 1代表非标
            })
          } else {
            Attributeslist.push(element.Currentvalueid)
          }
        })
      }
      let type = 0
      if (this.FormData.type === '非标') {
        type = 1
      }
      ChangeMaterialInformation({
        ProductID: this.FormData.materiel_code,
        Product_Name: this.FormData.materiel_name,
        Attribute_Warehouse_Product_id: this.FormData.Attribute_Warehouse_Product_id,
        state: state,
        Attribute_Summary: this.FormData.material_subclass,
        ClassificationID: this.FormData.ClassificationID,
        type: type,
        Attributes_value_IDs: Attributeslist,
        Attributes_value_IDs1: Attributeslist1,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.getMaterialInformationList()
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 常规或非标切换的时候回调
    TypeChangeHandle (value) {
      if (value === '常规') {
        for (let i = 0; i < this.FormData.material_lists.length; ++i) {
          this.FormData.material_lists[i].Currentvalue = ''
          this.FormData.material_lists[i].Currentvalueid = ''
        }
      }
    }
  }
}
</script>
